import Gallery1 from "../../assets/gallery1.jpg";
import Gallery2 from "../../assets/gallery2.jpg";
import Gallery3 from "../../assets/gallery3.jpg";
import Gallery5 from "../../assets/gallery5.jpg";
import Gallery7 from "../../assets/gallery7.jpg";
import Gallery8 from "../../assets/gallery8.jpg";
import Gallery9 from "../../assets/gallery9.jpg";
import Gallery10 from "../../assets/gallery10.jpg";
import Gallery11 from "../../assets/gallery11.jpg";
import Gallery12 from "../../assets/gallery12.jpg";

export const photos = [
  {
    src: Gallery2,
    width: 2,
    height: 3,
  },
  {
    src: Gallery3,
    width: 2,
    height: 3,
  },
  {
    src: Gallery1,
    width: 3,
    height: 2,
  },

  {
    src: Gallery5,
    width: 2,
    height: 3,
  },
  {
    src: Gallery7,
    width: 2,
    height: 3,
  },

  {
    src: Gallery9,
    width: 3,
    height: 2,
  },
  {
    src: Gallery10,
    width: 2,
    height: 3,
  },
  {
    src: Gallery12,
    width: 2,
    height: 3,
  },
  {
    src: Gallery11,
    width: 2,
    height: 3,
  },
  {
    src: Gallery8,
    width: 3,
    height: 2,
  },
];
